/* eslint-disable import/no-default-export */
import { Noun, Verb, trackUe } from '@trello/analytics';
import { State } from 'app/gamma/src/modules/types';
import {
  updatePassword,
  updatePasswordError,
} from 'app/gamma/src/modules/state/models/session';
import React from 'react';
import { connect } from 'react-redux';
import { getMe } from 'app/gamma/src/selectors/members';
import { MemberModel } from 'app/gamma/src/types/models';
import { Dispatch } from 'app/gamma/src/types';
import { ChangePassword } from './change-password';

interface ChangePasswordContainerProps {
  changePassword: (data: object) => void;
  me: MemberModel;
  errors: string[];
}

class ChangePasswordContainer extends React.Component<
  ChangePasswordContainerProps
> {
  componentDidMount() {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.CHANGE_PASSWORD,
      context: 'Change password popover opened in header',
    });
  }

  hasPassword = () => {
    const { loginTypes } = this.props.me;

    return !!(loginTypes && loginTypes.includes('password'));
  };

  render() {
    const { changePassword, errors } = this.props;

    return (
      <ChangePassword
        onChangePassword={changePassword}
        hasPassword={this.hasPassword()}
        errors={errors}
      />
    );
  }
}

function mapStateToProps(
  state: State,
  ownProps: object,
): {
  me: MemberModel | undefined;
  errors: string[];
} {
  const me = getMe(state);

  return {
    me,
    errors: state.ui.errors.changePassword,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: Dispatch, ownProps: any) {
  return {
    changePassword(data: {
      oldPassword: string;
      password1: string;
      password2: string;
    }) {
      const { password1, password2 } = data;
      if (password1 || password2) {
        if (password1 !== password2) {
          dispatch(updatePasswordError('must match'));
        } else {
          dispatch(updatePassword(data));
        }
      }
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePasswordContainer);
